import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { FormProvider, useForm } from 'react-hook-form';
import { TMember } from '../../../types';
import { AvatarSelect } from '../../base';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getMembers } from '../../../store/team/selectors';
import { TCreateEditForm } from '../../form';

const CustomEditAvatar = (props: GridRenderEditCellParams) => {
  const { id, value, field } = props;

  const apiRef = useGridApiContext();

  const members = useAppSelector(getMembers);

  const methods = useForm<TCreateEditForm>({
    mode: 'all',
  });

  const handleChange = (member: TMember | null) => {
    apiRef.current?.setEditCellValue({
      id,
      field,
      value: member,
    });
  };

  return (
    <FormProvider {...methods}>
      <AvatarSelect
        onChange={handleChange}
        options={members}
        value={value}
        size="medium"
        sx={{
          borderRadius: 0,
        }}
      />
    </FormProvider>
  );
};

export {
  CustomEditAvatar,
};
